export class NeedNormalizationError extends Error {}
